/**
 * O dia corrente em São Paulo, como `AAAA-MM-DD` — o formato do campo de data e o mesmo dia que o
 * servidor usa. Pelo relógio UTC, depois das 21h já seria amanhã.
 */
export const hojeEmSaoPaulo = (agora: Date = new Date()): string =>
  new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Sao_Paulo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(agora);
